/**
 * Shim for `react-native-loading-spinner-overlay`. Renders a fixed overlay with
 * a spinner and optional text while `visible` is true.
 */
import React from 'react';
import { createPortal } from 'react-dom';
import { ActivityIndicator } from '../web/react-native';
import { toCss } from '../web/styleUtils';

export interface SpinnerProps {
  visible?: boolean;
  textContent?: string;
  color?: string;
  overlayColor?: string;
  size?: 'small' | 'large' | number;
  textStyle?: any;
  animation?: string;
  className?: string;
  style?: any;
  [key: string]: any;
}

const Spinner = function Spinner({
  visible,
  textContent,
  color = '#fff',
  overlayColor = 'rgba(0,0,0,0.5)',
  size = 'large',
  textStyle,
}: SpinnerProps) {
  if (!visible) return null;
  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: overlayColor,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        gap: 12,
      }}
    >
      <ActivityIndicator size={size} color={color} />
      {textContent ? <div style={{ color, ...(toCss(textStyle) as any) }}>{textContent}</div> : null}
    </div>,
    document.body,
  );
};

export default Spinner;
